import { gql } from '@apollo/client';

export const BIND_MCP_OAUTH_TENANT = gql`
  mutation BindMcpOauthTenant($tenantId: ID!) {
    bindMcpOauthTenant(tenantId: $tenantId) {
      userId
      tenantId
    }
  }
`;
